export const portfolioData = {
  name: "Lokesh",
  title: "Full-stack developer and experiment-driven problem solver",
  professionalSummary:
    "Experienced in building scalable applications and automating workflows using AI, combining MERN stack development with AI-powered systems to reduce manual effort and improve efficiency.",
  aboutParagraphs: [
    "I am a builder who focuses on solving real-world problems through experimentation and technology. My work revolves around developing full-stack applications and integrating AI to automate repetitive tasks.",
    "I enjoy taking ideas from concept to execution, whether it is building platforms like learning systems or designing automation tools that significantly reduce manual work. My approach is rooted in continuous experimentation, optimization, and learning.",
  ],
  aboutCards: [
    {
      title: "Working Style",
      heading: "Build, test, refine, repeat.",
      description:
        "I like systems that can be improved through experimentation, measured through outcomes, and scaled through clean technical decisions.",
    },
    {
      title: "Focus Area",
      heading: "Full-stack + AI in one workflow.",
      description:
        "I combine application engineering with LLM-powered logic, retrieval workflows, and automation layers to create practical end-to-end products.",
    },
    {
      title: "Core Driver",
      heading: "Reduce repetitive manual effort.",
      description:
        "The best projects are the ones that improve productivity, simplify complex processes, and create visible operational efficiency.",
    },
  ],
  brandStatement:
    "I build intelligent systems that reduce manual effort through automation and AI.",
  futureVision:
    "To develop scalable AI-powered platforms that automate complex workflows and improve productivity across industries, while continuously experimenting with emerging technologies like GenAI and intelligent systems.",
  heroPills: [
    "MERN Stack Applications",
    "LLM + RAG Workflows",
    "Automation-First Problem Solving",
  ],
  terminalLines: [
    "specialization: scalable applications + AI-powered automation",
    "approach: experimentation, optimization, continuous learning",
    "focus: full-stack systems, intelligent tooling, workflow efficiency",
    "mission: turn real-world problems into practical digital products",
  ],
  focusAreas: [
    {
      title: "Adaptive Systems",
      description: "Learning and product experiences shaped around user interaction.",
    },
    {
      title: "Evaluation Workflows",
      description: "AI-assisted analysis pipelines with stronger speed and consistency.",
    },
    {
      title: "Automation Layers",
      description: "Google Sheets and Apps Script integrations that remove repetitive work.",
    },
    {
      title: "Scalable Products",
      description: "Architectures designed to grow without losing clarity or maintainability.",
    },
  ],
  skillGroups: [
    {
      title: "Full Stack Development",
      items: [
        "MERN Stack (MongoDB, Express.js, React, Node.js)",
        "HTML, CSS, JavaScript",
        "SQL Databases",
      ],
    },
    {
      title: "AI & Automation",
      items: [
        "LLM Integration",
        "RAG (Retrieval-Augmented Generation)",
        "Generative AI Applications",
        "AI-based Evaluation Systems",
      ],
    },
    {
      title: "Automation & Tools",
      items: [
        "Google Apps Script",
        "Google Sheets Automation",
        "Workflow Optimization",
      ],
    },
  ],
  projects: [
    {
      name: "Adaptive LMS",
      summary: "A full-stack adaptive learning platform built with MERN.",
      points: [
        "Built a full-stack adaptive learning platform using MERN.",
        "Designed dynamic content delivery based on user interaction.",
        "Integrated intelligent features to enhance learning experience.",
      ],
      tags: ["MERN", "Adaptive Learning", "Scalable Architecture"],
    },
    {
      name: "Hall of Fame Platform",
      summary: "A recognition-based platform built for achievements and structured engagement.",
      points: [
        "Developed a recognition-based platform to highlight achievements.",
        "Focused on user engagement and structured data handling.",
        "Implemented scalable backend architecture.",
      ],
      tags: ["User Engagement", "Structured Data", "Backend Systems"],
    },
    {
      name: "AI Evaluation & Automation System",
      summary: "An AI-powered workflow system built to reduce manual evaluation effort.",
      points: [
        "Created AI-powered evaluation workflows using LLMs.",
        "Automated analysis processes with improved accuracy.",
        "Reduced manual effort significantly through intelligent automation.",
        "Integrated with tools like Google Sheets and Apps Script.",
      ],
      tags: ["LLMs", "Automation", "Google Apps Script", "Google Sheets"],
    },
  ],
  tools: [
    "MERN Stack",
    "Python",
    "SQL",
    "Google Sheets",
    "Google Apps Script",
    "LLM APIs",
    "RAG Architecture",
    "GenAI Tools",
  ],
  strengths: [
    "Strong problem-solving mindset",
    "Ability to combine full-stack + AI",
    "Automation-first thinking",
    "Rapid experimentation and iteration",
    "Building practical, real-world solutions",
  ],
  contacts: {
    email: "lokeshk80964@gmail.com",
    linkedin: "https://www.linkedin.com/in/krovvidi-lokesh-395210237",
    github: "https://github.com/Lokesh8096",
  },
};
